/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo, useState } from 'react'
import { const_var, params } from '../../../../../../../../redux/reducers/reducer';

import { delModel, extrudeSettings, wainscotTrimModel } from '../../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { MaterialTrim, MaterialWainScotTrimNew } from '../../../../../../CustomMaterial';

const TrimModel = () => {
    const [sideWallCloseSize, setSideWallCloseSize] = useState(0);

    const railWidth = 0.2;
    let offset;
    
    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])

    if(params.leanF_p_d % legDistance === 0) offset = 0.1;
    else offset = 0;

    const trimPosOffset = useMemo(() => {
        if(params.frontLeanStoragePosition > 0 && params.frontLeanStoragePosition !== params.leanF_p_d - parseInt(params.add_storage_front) - 0.2) return railWidth;
        else return 0;
    }, [params.frontLeanStoragePosition, params.leanF_p_d, params.add_storage_front])

    const backWallVrTrimModelTwo = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(params.leanF_p_d / 2 + 0.01), 0);
        model.lineTo(-(params.leanF_p_d / 2 + 0.01), sideWallCloseSize);
        model.lineTo(-(params.leanF_p_d / 2 - 0.19), sideWallCloseSize);
        model.lineTo(-(params.leanF_p_d / 2 - 0.19), 0);
        model.closePath();

        return model;
    }, [params.add_storage_check_front, sideWallCloseSize, params.p_b_c_b_f_b, params.add_left_front_lean_porch, params.leanF_p_h, params.leanF_p_d, params.p_b_c_b_f_l])

    const storageFrontWall = useMemo(() => {
        let wainscot, trim;
        const meshStorageFrontWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.leanF_p_w - 0.04)))
        const meshFrontStorageDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('frontLeanStorageFront', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
        const meshTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(backWallVrTrimModelTwo, extrudeSettings(0.22)));
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('frontLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
        
        let meshStorageFrontWainscotModel_Temp = meshStorageFrontWainscotModel.clone();
        meshStorageFrontWainscotModel_Temp.position.set((params.leanF_p_d / -2  + parseInt(params.add_storage_front) + 0.085), 3 , -params.leanF_p_w + 0.15)
        meshStorageFrontWainscotModel_Temp.updateMatrixWorld();
    
        let meshFrontStorageDelModel_Temp = meshFrontStorageDelModel.clone();
        meshFrontStorageDelModel_Temp.position.set((params.leanF_p_d / -2  + parseInt(params.add_storage_front)) - 0.5, 0, -( params.p_d/2 + params.leanF_p_w ));
        meshFrontStorageDelModel_Temp.rotation.y = Math.PI/2
        meshFrontStorageDelModel_Temp.updateMatrixWorld();

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(-params.leanF_p_pos - params.frontLeanStoragePosition, 0, -0.05);
        meshSideDelModel_Temp.updateMatrixWorld();
        
        let meshTrimModel_Temp = meshTrimModel.clone();
        meshTrimModel_Temp.position.set(parseInt(params.add_storage_front) + 1.6 * offset - 0.08, 0, 0)
        meshTrimModel_Temp.updateMatrixWorld();
    
        const meshStorageFrontWainscotModel_CSG = CSG.fromMesh(meshStorageFrontWainscotModel_Temp);
        const meshFrontStorageDelModel_CSG = CSG.fromMesh(meshFrontStorageDelModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);
        const meshTrimModel_CSG = CSG.fromMesh(meshTrimModel_Temp);
    
        const storagefrontWainscotModel_CSG = meshStorageFrontWainscotModel_CSG.subtract(meshFrontStorageDelModel_CSG);
        const SideDelModel_CSG = storagefrontWainscotModel_CSG.subtract(meshSideDelModel_CSG);
        const meshTrimDelModel_CSG = meshTrimModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGStorageFrontWainscotModel = CSG.toMesh(SideDelModel_CSG,new THREE.Matrix4())
        const meshTrimDelModel = CSG.toMesh(meshTrimDelModel_CSG, new THREE.Matrix4());

        wainscot = CSGStorageFrontWainscotModel.geometry;
        trim = meshTrimDelModel.geometry;
        return {wainscot, trim}
    }, [params.p_d, params.leanF_p_w, params.leanF_p_d, params.add_storage_front, params.frontLeanStoragePosition, const_var.newDoorsArray, params.leanF_p_pos, backWallVrTrimModelTwo])
    
    // --- side wall set    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_f_l === 'Open' || typeof(params.p_b_c_b_f_l) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.leanF_p_h + 0.05;
            } else {
                tempWallCloseSize = params.leanF_p_h;
            }
        } else if (params.p_b_c_b_f_l === "One_Fourth_Close") {
            tempWallCloseSize = params.leanF_p_h / 4 * 3;
        } else if (params.p_b_c_b_f_l === "Half_Close") {
            tempWallCloseSize = params.leanF_p_h / 2;
        } else if (params.p_b_c_b_f_l === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanF_p_h / 4;
        } else if (params.p_b_c_b_f_l === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.leanF_p_h - 3 * params.p_b_c_b_f_l;
        }

        setSideWallCloseSize(tempWallCloseSize);
    }, [params.p_b_c_b_f_l, params.leanF_p_h, params.p_r_s])
    
    return (
        <group position={[trimPosOffset, 0, params.p_d / 2 + params.leanF_p_w + 0.01]}>
            <mesh name="storage-wall-trim" geometry={storageFrontWall.trim}>
                <MaterialTrim visibleSection={"frontLean"} />
            </mesh>

            {params.p_w_c_n === true && storageFrontWall &&
                <mesh name="wainscotTrim" geometry={storageFrontWall.wainscot} position={[3 * offset / 2 - 0.05, 0, 0]}>
                    <MaterialWainScotTrimNew   visibleSection={"frontLean"}/>
                </mesh>
            }
        </group>
    )
}

export default TrimModel